import { generateSkinDefaults } from '@wix/editor-elements-panel';
import { Skins } from './constants';

export const megaMenuContainerItemSkinDefinition = {
  [Skins.dropdownContainerSkin]: {
    'dropdown-container-margin-block-start': {
      type: 'SIZE',
      defaultValue: '0px',
      state: 'regular',
    },
    'dropdown-container-margin-inline-start': {
      type: 'SIZE',
      defaultValue: '0px',
      state: 'regular',
    },
    'dropdown-container-justify-content': {
      type: 'CSSString',
      defaultValue: 'start',
      state: 'regular',
    },
  },
} as const;

export default generateSkinDefaults(megaMenuContainerItemSkinDefinition);
